var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation'),(_vm.adsvisible)?_c('vodafoneads'):_vm._e(),_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c(_vm.currentComponent,{tag:"component"})],1),_c('sitefooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }